import Vue from "vue";
import Router from "vue-router";
import Imprint from "./views/Imprint.vue";
import Student from "./views/Student.vue";
import Employer from "./views/Employer.vue";
import About from "./views/About.vue";
import Jobs from "./views/Jobs.vue";
import Application from "./views/Application.vue";

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Employer Page",
      component: Employer,
    },
    {
      path: "/student",
      name: "Student Page",
      component: Student,
    },
    {
      path: "/about",
      name: "About Page",
      component: About,
    },
    {
      path: "/imprint",
      name: "Imprint Page",
      component: Imprint,
    },
    {
      path: "/jobs",
      name: "Jobs Page",
      component: Jobs,
    },
    {
      path: "/apply",
      name: "Application Page",
      component: Application,
    },
    /*{
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup,
    },*/
  ],
  mode: "history",
});
